import type { LightboxElements } from './types';

export function findLightboxElement(): HTMLElement | null {
    const lightboxElement = document.querySelector<HTMLElement>('.mp-lightbox');

    if (!lightboxElement) {
        console.warn('Lightbox: .mp-lightbox element not found. Include @include("partials.lightbox") in your layout.');
        return null;
    }

    return lightboxElement;
}

export function getElements(lightboxElement: HTMLElement): LightboxElements {
    return {
        lightbox: lightboxElement,
        img: lightboxElement.querySelector<HTMLImageElement>('.mp-lightbox__image')!,
        caption: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__caption')!,
        counter: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__counter')!,
        current: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__current')!,
        total: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__total')!,
        closeBtn: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__close')!,
        prevBtn: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__prev')!,
        nextBtn: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__next')!,
        zoomIn: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__zoom-in')!,
        zoomOut: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__zoom-out')!,
        zoomReset: lightboxElement.querySelector<HTMLButtonElement>('.mp-lightbox__zoom-reset')!,
        zoomLevelDisplay: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__zoom-level')!,
        backdrop: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__backdrop')!,
        content: lightboxElement.querySelector<HTMLElement>('.mp-lightbox__content')!
    };
}
